export function prepareBookedEventsDataWithConflictingInvoices(bookedEvents, conflictingInvoices) {
  return bookedEvents.map((bookedEvent) => {
    const conflictingInvoice = conflictingInvoices.find((invoice) =>
      invoice.includedBookedEventIds?.includes(bookedEvent.id),
    )
    return {
      ...bookedEvent,
      conflictingInvoice,
    }
  })
}
